import styled from 'styled-components';
import Button from '../../../../../components/Button';

export const ButtonStyle = styled(Button)`
  width: 170px;
  border-radius: 0;

  &:hover {
    background-color: #6200ea;
    color: #fff;
  }
`;

export const LabelWrapStyle = styled.div`
  width: 70px;
`;

export const CriteriaContainerStyle = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 0;
`;
export const ButtonWrapStyle = styled.div`
  display: flex;
`;
